import { ProfessionalCard } from '@components/Consultation/components/ProfessionalCard'

import { useConsultationType } from '@/hooks/useConsultationType'
import { getSlugTranslation } from '@/locale/utils'
import { isVideoConsultation } from '@/utils/consultation'

export const Match = () => {
  const { consultationType } = useConsultationType()

  const isVideo = isVideoConsultation(consultationType)
  return (
    <div className="flex flex-1 flex-col items-center gap-4 p-4" data-testid="match-container">
      <ProfessionalCard
        footer={
          !isVideo && (
            <p className="text-gray-text w-full rounded-lg bg-gray-100 p-2 text-center text-sm">
              {getSlugTranslation(`general.consultation.hint.waitingTime`)}
            </p>
          )
        }
        reviewing={isVideo}
      >
        <p className="text-center whitespace-break-spaces">{getSlugTranslation('reviewing')}</p>
      </ProfessionalCard>

      {isVideo && <p className="mt-2 text-center">{getSlugTranslation('general.consultation.videoConsultation.hint.joinCallNotification')}</p>}
    </div>
  )
}
